<template>
    <div
        class="scanner-container"
        :class="{show}"
    >
        <div
            v-if="!newResult && !existingResult"
            class="scanner-wrapper"
        >
            <h1>Scan Fire Extinguisher</h1>
            <p>Position the QR code within the red box on the camera to scan the code</p>
            <qr-scanner
                v-model="qrCode"
                v-if="show"
            />
            <div>
                <p>Or enter the code manually below:</p>
                <input
                    type="text"
                    v-model.lazy="qrCode"
                    class="form-control"
                    placeholder="Or type the code here"
                >
            </div>
            <p v-if="message">
                {{ message }}
            </p>
            <button
                class="btn btn-dark btn-lg"
                @click.prevent="cancel"
            >
                Cancel
            </button>
            <button
                class="btn btn-dark btn-lg"
                @click.prevent="clear"
            >
                Clear
            </button>
        </div>
        <div v-if="newResult">
            <h1>New Fire Extinguisher</h1>
            <fe-form
                :fe-id="null"
                :fe-code="qrCode"
                @back="resetResult"
            />
        </div>
        <div v-if="existingResult">
            <h1>Edit Fire Extinguisher</h1>
            <fe-form
                :fe-id="result.id"
                @back="resetResult"
            />
        </div>
    </div>
</template>
<script>
import QrScanner from '../QRScannerComponent';
import Service from '../../services/FireExtinguishersService';
import FeForm from './FormComponent';
export default {
    components: {
        QrScanner,
        FeForm,
    },
    props: {
        show: {
            required: false,
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            qrCode: null,
            message: null,
            result: null,
        };
    },
    computed: {
        newResult () {
            return this.result !== null && typeof this.result.id === 'undefined';
        },
        existingResult () {
            return this.result !== null && typeof this.result.id !== 'undefined';
        }
    },
    watch: {
        qrCode () {
            if (!this.qrCode) {
                return;
            }
            this.$emit('read', this.qrCode);
            this.message = 'Scanned successfully';
            this.lookup();
        }
    },
    methods: {
        cancel () {
            this.$emit('cancel');
        },
        clear () {
            this.qrCode = '';
        },
        lookup () {
            this.message = 'Searching...'
            Service.index({code: this.qrCode}).then(res => {
                const results = res.data.data;
                if (typeof results[0] !== 'undefined') {
                    this.message = 'Result found';
                    this.result = results[0]
                    this.$emit('result', this.result);
                    return;
                }
                this.message = 'No result found';
                this.result = {code: this.qrCode}
                this.$emit('result', this.result);
            }).catch(() => {
                this.message = 'Error, please try again';
            })
        },

        resetResult () {
            this.result = null;
            this.clear();
        }
    }
}
</script>
<style lang="scss" scoped>
.scanner-container {
    position: fixed;
    transition: top ease .5s;
    top: 100vh;
    left: 0;
    width: 100vw;
    height: 100vh;
    text-align: center;
    background: white;
    padding: 90px 10px 10px;

    &.show {
        top: 0;
    }
}
.scanner-wrapper {
    width: 400px;
    margin: 0 auto;
    max-width: 90%;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/fireExtinguishers/ScannerComponent.vue